import React, { FC } from "react";
import { ColoredTextProps } from "@components/Typography/types";
const DescriptionText: FC<ColoredTextProps> = ({ coloredText, tag = "h2", customClass }) => {
    const CustomTag = `${tag}`;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <CustomTag className={`app-description-text ${customClass}`}>{coloredText}</CustomTag>;
};
export default DescriptionText;
